<template>
    <div class="questionnaire pt-5 pb-2">
        <div class="row justify-content-around">
            <div class="col-md-6" style="min-height:300px;">



                <transition-group name="list" tag="div">
                    <div v-if="dataloaded===true" key='intro' id="intro" class="card shadow mt-3 speech-bubble-left">
                        <div class="card-body">
                            <div v-html="questionnaire.intro_html"> </div>

                            <div v-if="!started" class="row justify-content-center">
                                <div class="col-md-8">
                                    <button type="button" class="btn btn-lg_ btn-block btn-primary zoomhover" v-text="'Los!'" @click="start();"></button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="show_registration" key='registration' id="registration" class="card shadow mt-3 speech-bubble-left">
                        <div class="card-body">
                            <div v-html="questionnaire.register_html"> </div>
                            <div class="my-2 mt-3 mb-4">

                                <div  class="row justify-content-center">

                                    <div v-if="(questionnaire.registration_type=='pre' && questionnaire.tasks==='visitor_ticket') && fieldActiveByVisitorType('timeslot','pre')" class="col-md-8 mb-1" v-bind:class="{ 'error': registration.errors.timeslot }">
                                        <label>Zeit-Slot</label>
                                        <select :disabled="started" class="custom-select mb-3" v-model="registration.input.timeslot">
                                            <option value="">Bitte wählen</option>
                                            <option v-if="timeslot.active==='1'" v-for="timeslot in questionnaire.exhibition.timeslots" :value="timeslot.index" :disabled="timeslot.active==='1' ? false:'disabled'">Slot {{timeslot.index+1}}: {{timeslot.timeinfo}}</option>
                                        </select>
                                    </div>

                                    <div v-if="(questionnaire.registration_type=='pre' || questionnaire.registration_type=='none') && fieldActiveByVisitorType('gender','pre')" class="col-md-8 mt-2 mb-3" v-bind:class="{ 'error': registration.errors.gender }">
                                        <label>Geschlecht</label>
                                        <div class="row">
                                            <div class="col">
                                                <div class="custom-control custom-radio custom-control-inline">
                                                    <input :disabled="started" type="radio" id="gender" name="gender" value="female" class="custom-control-input" v-model="registration.input.gender">
                                                    <label class="custom-control-label" for="gender">weiblich</label>
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="custom-control custom-radio custom-control-inline">
                                                    <input :disabled="started" type="radio" id="gender2" name="gender" value="male" class="custom-control-input" v-model="registration.input.gender">
                                                    <label class="custom-control-label" for="gender2">männlich</label>
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="custom-control custom-radio custom-control-inline">
                                                    <input :disabled="started" type="radio" id="gender3" name="gender" value="divers" class="custom-control-input" v-model="registration.input.gender">
                                                    <label class="custom-control-label" for="gender3">divers</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>



                                    <div v-if="(questionnaire.registration_type=='pre'  || questionnaire.registration_type=='prepost2' || questionnaire.registration_type=='none') && fieldActiveByVisitorType('firstname','pre')" class="col-md-8 mb-1" v-bind:class="{ 'error': registration.errors.firstname }">
                                        <label>Vorname</label>
                                        <input :disabled="started"  type="text" v-model="registration.input.firstname" class="form-control form-control-lg form-control-tb mb-2">
                                    </div>
                                    <div v-if="(questionnaire.registration_type=='pre' || questionnaire.registration_type=='none') && fieldActiveByVisitorType('lastname','pre')" class="col-md-8 mb-1" v-bind:class="{ 'error': registration.errors.lastname }">
                                        <label>Nachname</label>
                                        <input :disabled="started"  type="text" v-model="registration.input.lastname" class="form-control form-control-lg form-control-tb mb-2">
                                    </div>

                                    <div v-if="fieldActiveByVisitorType('email','pre')" class="col-md-8 mb-1" v-bind:class="{ 'error': registration.errors.email }">
                                        <label>E-Mail:</label>
                                        <input :disabled="started" type="email" v-model="registration.input.email" class="form-control form-control-lg form-control-tb mb-2">
                                        <label>E-Mail wiederholen:</label>
                                        <input :disabled="started" type="email" v-model="registration.input.emailagain" class="form-control form-control-lg form-control-tb mb-2">
                                        <div  v-if="questionnaire.optinmail_active==1" class="smallnote">Bitte durch Klick auf den Aktivierungslink in unserer Opt-In-E-Mail die E-Mail-Adresse bestätigen. Falls diese E-Mail nicht ankommt, bitte den Spam-Ordner checken.</div>
                                    </div>

                                    <div v-if="(questionnaire.registration_type=='pre' || questionnaire.registration_type=='none') && fieldActiveByVisitorType('birthday','pre')" class="col-md-8 mb-1" v-bind:class="{ 'error': registration.errors.birthday }">
                                        <label>Geburtstag</label>
                                        <div class="">
                                            <input type="hidden" id="birthday_field" name="birthday_field" v_model="registration.input.birthday">
                                            <dropdown-datepicker :disabled="started" _v-model="registration.input.birthday" v-bind:on-change="onBirthdayChange" submit-id="birthday_field" ref="birthday"
                                                display-format="dmy" day-label="Tag" month-label="Monat" year-label="Jahr" min-date="1990-01-01" max-date="2006-12-31" v-bind:required="true" dropdownClass="form-control"
                                                wrapperClass="input-group mb-3" :day-suffix-values="['.', '.', '.', '.']" month-format="short"
                                                :monthLongValues="['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember']"
                                                :monthShortValues="['Jan.', 'Feb.', 'März', 'Apr.', 'Mai', 'Jun.', 'Jul.', 'Aug.', 'Sep.', 'Okt.', 'Nov.', 'Dez.']"
                                            ></dropdown-datepicker>
                                        </div>
                                    </div>

                                    <div v-if="(questionnaire.registration_type=='pre' || questionnaire.registration_type=='none') && fieldActiveByVisitorType('school_state','pre')" class="col-md-8 mb-1" v-bind:class="{ 'error': registration.errors.school_state }">
                                        <label>Bundesland</label>
                                        <select :disabled="started" class="custom-select mb-3" v-model="registration.input.school_state">
                                            <option disabled value="">Bitte wählen</option>
                                            <option value="Baden-Württemberg">Baden-Württemberg</option>
                                            <option value="Bayern">Bayern</option>
                                            <option value="Berlin">Berlin</option>
                                            <option value="Brandenburg">Brandenburg</option>
                                            <option value="Bremen">Bremen</option>
                                            <option value="Hamburg">Hamburg</option>
                                            <option value="Hessen">Hessen</option>
                                            <option value="Mecklenburg-Vorpommern">Mecklenburg-Vorpommern</option>
                                            <option value="Niedersachsen">Niedersachsen</option>
                                            <option value="Nordrhein-Westfalen">Nordrhein-Westfalen</option>
                                            <option value="Rheinland-Pfalz">Rheinland-Pfalz</option>
                                            <option value="Saarland">Saarland</option>
                                            <option value="Sachsen">Sachsen</option>
                                            <option value="Sachsen-Anhalt">Sachsen-Anhalt</option>
                                            <option value="Schleswig-Holstein">Schleswig-Holstein</option>
                                            <option value="Thüringen">Thüringen</option>
                                        </select>
                                    </div>

                                    <div v-if="(questionnaire.registration_type=='pre' || questionnaire.registration_type=='none')  && fieldActiveByVisitorType('school_type','pre')" class="col-md-8 mt-2 mb-3" v-bind:class="{ 'error': registration.errors.school_type }">
                                        <label>Geht Ihr Kind auf eine Schule mit Möglichkeit auf Abitur?</label>
                                        <div class="row">
                                            <div class="col">
                                                <div class="custom-control custom-radio custom-control-inline">
                                                    <input :disabled="started" type="radio" id="school_type" name="school_type" value="SMA"  class="custom-control-input" v-model="registration.input.school_type">
                                                    <label class="custom-control-label" for="school_type">Ja</label>
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="custom-control custom-radio custom-control-inline">
                                                    <input :disabled="started" type="radio" id="school_type2" name="school_type" value="SOA" class="custom-control-input" v-model="registration.input.school_type">
                                                    <label class="custom-control-label" for="school_type2">Nein</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div v-if="(questionnaire.registration_type=='pre' || questionnaire.registration_type=='none') && fieldActiveByVisitorType('older13','pre')" class="col-md-8 mb-2" v-bind:class="{ 'error': registration.errors.older13 }">
                                        <div class="form-check">
                                            <input :disabled="started" class="form-check-input" type="checkbox" value="" id="defaultCheck0" v-model="registration.input.older13">
                                            <label class="form-check-label" for="defaultCheck0">
                                                Hiermit bestätige ich, dass ich 14 Jahre oder älter bin. (Pflichtangabe)
                                            </label>
                                        </div>
                                    </div>

                                    <div v-if="fieldActiveByVisitorType('dsgvo','pre')" class="col-md-8 mb-2" v-bind:class="{ 'error': registration.errors.dsgvo }">
                                        <div class="form-check">
                                            <input :disabled="started" class="form-check-input" type="checkbox" value="" id="defaultCheck1" v-model="registration.input.dsgvo">
                                            <label class="form-check-label" for="defaultCheck1">
                                                Ja, ich habe die Datenschutz&shy;bestimmungen gelesen, verstanden und akzeptiert (<a href="/datenschutzbestimmungen-und-impressum" target="_blank" style="text-decoration:underline;">siehe hier</a>).
                                            </label>
                                        </div>
                                    </div>

                                    <div v-if="(questionnaire.registration_type=='pre' || questionnaire.registration_type=='none') && fieldActiveByVisitorType('hygiene','pre')" class="col-md-8 mb-2" v-bind:class="{ 'error': registration.errors.hygiene }">
                                        <div class="form-check">
                                            <input :disabled="started" class="form-check-input" type="checkbox" value="" id="defaultCheckh1" v-model="registration.input.hygiene">
                                            <label class="form-check-label" for="defaultCheckh1">
                                                Ja, ich habe die <a href="https://admin.gubn.de/media/pdf/Schutz-_und_Hygienekonzept_GUBN_2021.pdf" target="_blank" style="text-decoration:underline;">Schutz- und Hygienehinweise</a> gelesen und werde mich vor Ort daran halten. (Pflichtangabe)
                                            </label>
                                        </div>
                                    </div>

                                </div>

                                <transition name="bounce">
                                <div v-if="registration.errors.email || registration.errors.firstname || registration.errors.lastname || registration.errors.dsgvo" class="text-red text-center">Bitte die Eingaben prüfen.</div>
                                </transition>

                            </div>
                            <div v-if="!started" class="row justify-content-center">
                                <div class="col-md-8">
                                    <button type="button" class="btn btn-lg_ btn-block btn-primary zoomhover" v-text="'Los geht’s'" @click="register();"></button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-for="(question,i) in bubbles" transition="list" :key="question.id" v-bind:id="'bubble'+question.id"  class="card shadow mt-3" v-bind:class="{ 'speech-bubble-right': question.status=='answered', 'speech-bubble-left': question.status!='answered' }">
                        <div class="card-body">


                            <!-- GENERAL QUESTION: -->

                           <h4 class="questiontext">{{ placeholders(question.question) }}</h4>

                           <p class="subline" v-if="question.properties.subline" v-html="placeholders(question.properties.subline)"></p>

                            <div v-if="question.properties.mainpic && question.status!='answered'" class="row justify-content-center hints-off-only">
                                <div class="col-sm-8 col-md-8 text-center my-3">
                                    <img :class="'img-fluid rounded mx-auto d-block '+question.properties.mainpicclass" :src="'/dynstorage/'+question.properties.mainpic+'?resize=w[500]e[false]s[false]'">
                                    <div v-if="question.properties.mainpiccaption"><small  style=" line-height: 0.7em;">{{ question.properties.mainpiccaption }}</small></div>
                                </div>
                            </div>


                            <!-- TYPE INFO: -->


                            <div v-if="question.type=='info' && question.properties.linkurl" class="my-2 mt-3">
                                <div  class="row justify-content-center">
                                    <div class="col-md-8">
                                            <a class="btn btn-lg_ btn-primary btn-block" target="_blank" :href="question.properties.linkurl" v-text="question.properties.linktext ? question.properties.linktext:'Link'"></a>
                                    </div>
                                </div>
                            </div>


                            <!-- TYPE INPUT: -->

                            <div v-if="question.type=='input'" class="my-2 mt-3 mb-4">
                                <div v-if="question.status=='answered'" class="row justify-content-center">

                                    <div v-if="question.answers.input1" class="col-md-8 mb-1" v-bind:class="{ 'error': question.errors.input1 }">
                                        <label v-if="question.properties.labelinput1">{{ question.properties.labelinput1 }}</label>
                                        <input  disabled="disabled" type="text" v-model="question.answers.input1" class="form-control form-control-lg form-control-tb mb-2">
                                    </div>

                                    <div v-if="question.properties.inputcount>=2 && question.answers.input2" class="col-md-8 mb-1" v-bind:class="{ 'error': question.errors.input2 }">
                                        <label v-if="question.properties.labelinput2">{{ question.properties.labelinput2 }}</label>
                                        <input  disabled="disabled" type="text" v-model="question.answers.input2" class="form-control form-control-lg form-control-tb mb-2">
                                    </div>

                                    <div v-if="question.properties.inputcount>=3 && question.answers.input3" class="col-md-8 mb-1" v-bind:class="{ 'error': question.errors.input3 }">
                                        <label v-if="question.properties.labelinput3">{{ question.properties.labelinput3 }}</label>
                                        <input disabled="disabled" type="text" v-model="question.answers.input3" class="form-control form-control-lg form-control-tb mb-2">
                                    </div>

                                </div>
                                <div v-else class="row justify-content-center">

                                    <div class="col-md-8 mb-1" v-bind:class="{ 'error': question.errors.input1 }">
                                        <label v-if="question.properties.labelinput1">{{ question.properties.labelinput1 }}</label>
                                        <input type="text" v-model="question.answers.input1" @focus="removeErrorMessages(i)" class="form-control form-control-lg form-control-tb mb-2">
                                    </div>

                                    <div v-if="question.properties.inputcount>=2" class="col-md-8 mb-1" v-bind:class="{ 'error': question.errors.input2 }">
                                        <label v-if="question.properties.labelinput2">{{ question.properties.labelinput2 }}</label>
                                        <input type="text" v-model="question.answers.input2" @focus="removeErrorMessages(i)" class="form-control form-control-lg form-control-tb mb-2">
                                    </div>

                                    <div v-if="question.properties.inputcount>=3" class="col-md-8 mb-1" v-bind:class="{ 'error': question.errors.input3 }">
                                        <label v-if="question.properties.labelinput3">{{ question.properties.labelinput3 }}</label>
                                        <input type="text" v-model="question.answers.input3" @focus="removeErrorMessages(i)" class="form-control form-control-lg form-control-tb mb-2">
                                    </div>

                                </div>
                                <transition name="bounce">
                                <div v-if="question.errors.input1 || question.errors.input2 || question.errors.input3" class="text-red text-center">Bitte prüfe die Eingabe</div>
                                </transition>
                            </div>



                            <!-- TYPE SINGLE/MULTIPLE CHOICE WITH PICS: -->


                            <div v-if="question.type=='singlechoice' || question.type=='multiplechoice'" class="my-2 mx-3 mt-3 mb-4" v-bind:class="question.status">

                                <div v-for="n in 6" :key="n+'.'+question.id" v-bind:class="{ 'selected': isTagActive(question,question.properties['optionid'+n]), 'notselected': !isTagActive(question,question.properties['optionid'+n]) }">
                                    <div v-if="n<=question.properties.inputcount" class="row justify-content-center rounded-lg lightborder shadow p-0 my-3"
                                        v-bind:class="{ 'active': isTagActive(question,question.properties['optionid'+n]) }">
                                        <div class="col px-0">
                                            <div class="row no-gutters pointer" @click="toggleTag(question, i, question.properties['optionid'+n] )">

                                                <div v-if="question.properties['optionpic'+n]" class="col-3 col-sm-3 col-md-4  align-self-center">
                                                    <span>
                                                        <img class="img-fluid rounded-left-lg" :src="'/dynstorage/'+question.properties['optionpic'+n]+'?resize=w[200]h[200]e[true]s[false]'">
                                                    </span>
                                                </div>

                                                <div v-if="question.properties['optionpic'+n]" class="col-8 col-sm-7 col-md-6 align-self-center px-2">
                                                    <div class="h4 answertext" v-text="question.properties['optiontext'+n]"></div>
                                                </div>
                                                <div v-else class="col-11 col-sm-10 col-md-10 align-self-center px-2">
                                                    <div class="h4 answertext" v-text="question.properties['optiontext'+n]"></div>
                                                </div>

                                                <div class="col-1 text-right align-self-center pr-2 my-3 text-center">

                                                    <svg width="20px" height="20px" viewBox="0 0 30 30" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                                        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                                            <g id="Artboard">
                                                                <circle id="Oval" fill="#D8D8D8" cx="15" cy="15" r="15"></circle>
                                                                <circle v-if="!isTagActive(question,question.properties['optionid'+n])" id="Oval-Copy" fill="#FFFFFF" cx="15" cy="15" r="11"></circle>
                                                                <circle v-if=" isTagActive(question,question.properties['optionid'+n])" id="Oval-Copy" fill="#007F09" cx="15" cy="15" r="11"></circle>
                                                                <circle v-if="1==2" id="Oval-Copy-2" fill="#4A90E2" cx="15" cy="15" r="10"></circle>
                                                            </g>
                                                        </g>
                                                    </svg>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <transition name="bounce">
                                <div v-if="question.errors.general" class="text-red text-center">{{ question.errors.general }}</div>
                                </transition>

                            </div>


                            <!-- TYPE MULTIPLE CHOICE TAGS: -->

                            <div v-if="question.type=='multiplechoice_tags'" class="my-2 mx-0 mt-3 mb-4" v-bind:class="question.status">
                                <div class="text-center">
                                    <span v-for="(tag,key) in question.properties.tags" :key="tag.id" v-bind:data-key="key"
                                        @click="toggleTag(question,i,tag.id)" class="badge badge-tag badge-tag-gray badge-secondary mr-1 mb-2"
                                        v-bind:class="{ 'active': isTagActive(question,tag.id) }">
                                        <span :key="tag.id" v-text="tag.label"></span>
                                    </span>
                                    <div v-if="question.properties.notaglabel || question.properties.alltagslabel">
                                        <span v-if="question.properties.notaglabel" class="badge badge-tag badge-tag-danger mt-4 mr-1 mb-2"
                                            @click="noTags(i)" v-bind:class="{ 'active': !hasTags(question) }">
                                            <span v-text="question.properties.notaglabel"></span>
                                        </span>
                                        <span v-if="question.properties.allagslabel" class="badge badge-tag badge-tag-success mt-4 mr-1 mb-2"
                                              @click="allTags(question,i)" v-bind:class="{ 'active': hasAllTags(question,i) }">
                                            <span v-text="question.properties.alltagslabel"></span>
                                        </span>
                                    </div>
                                </div>
                                <transition name="bounce">
                                <div v-if="question.errors.general" class="text-red text-center">{{ question.errors.general }}</div>
                                </transition>
                            </div>


                            <!-- GENERAL FOOTNOTE: -->

                            <div v-if="question.properties.footnote" v-text="question.properties.footnote" class="small mb-2"></div>





                            <div v-if="question.type=='yesno' && question.status=='answered'" class="my-2 mt-3">
                                <div  class="row justify-content-center">
                                    <div v-if="clusters[question.properties.cluster][0]=='yes'" class="col">
                                        <button disabled="disabled" type="button" class="btn btn-lg_ btn-block btn-success zoomhover" v-text=" question.properties.labelyes ? question.properties.labelyes:'Ja'" @click="submitQuestion(i,'yes',question, $event)"></button>
                                    </div>
                                    <div v-if="clusters[question.properties.cluster][0]=='no'" class="col">
                                        <button disabled="disabled" type="button" class="btn btn-lg_ btn-block btn-danger zoomhover" v-text=" question.properties.labelno ? question.properties.labelno:'Nein'"  @click="submitQuestion(i,'no',question, $event)"></button>
                                    </div>
                                </div>
                            </div>


                            <!-- SUBMIT AREA: -->

                            <div v-if="question.status!='answered'">
                                <div v-if="question.type=='yesno'" class="my-2 mt-3">
                                    <div  class="row justify-content-center">
                                        <div class="col">
                                            <button type="button" class="btn btn-lg_ btn-block btn-success zoomhover" v-text=" question.properties.labelyes ? question.properties.labelyes:'Ja'" @click="submitQuestion(i,'yes',question, $event)"></button>
                                        </div>
                                        <div class="col">
                                            <button type="button" class="btn btn-lg_ btn-block btn-danger zoomhover" v-text=" question.properties.labelno ? question.properties.labelno:'Nein'"  @click="submitQuestion(i,'no',question, $event)"></button>
                                        </div>
                                    </div>
                                </div>
                                <div v-else>
                                    <div  class="row justify-content-center">
                                        <div class="col-md-8">
                                            <button type="button" class="btn btn-lg_ btn-block btn-primary zoomhover" v-text=" question.properties.labelsubmit ? question.properties.labelsubmit:'Weiter'" @click="submitQuestion(i,'submit',question, $event)"></button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- /  -->


                        </div>
                    </div>

                    <div v-if="show_registration2" key='registration2' id="registration2" class="card shadow mt-3 speech-bubble-left">
                        <div class="card-body">
                            <div v-html="questionnaire.register2_html"> </div>
                            <div class="my-2 mt-3 mb-4">

                                <div v-if="(questionnaire.registration_type=='post' || questionnaire.registration_type=='prepost1' || questionnaire.registration_type=='prepost2') && fieldActiveByVisitorType('schoolcode','post') && schoolcodeexists!=='yes'" class="row justify-content-center">
                                    <div v-if="fieldActiveByVisitorType('schoolcode','post')" class="col-md-8 mt-2 mb-3" v-bind:class="{ 'error': registration.errors.schoolcode }">
                                        <label>Schul- oder Teilnahmecode vorhanden?</label>
                                        <div class="row">
                                            <div class="col-md-8 mt-2">
                                                <div class="form-check form-check-inline">
                                                    <input :disabled="registered2ready" type="radio" id="sc1" name="schoolcodeexists" value="no" class="form-check-input" v-model="schoolcodeexists">
                                                    <label class="form-check-label" for="sc1">Nein</label>
                                                </div>
                                                <div class="form-check form-check-inline">
                                                    <input :disabled="registered2ready" type="radio" id="sc2" name="schoolcodeexists" value="yes" class="form-check-input" v-model="schoolcodeexists">
                                                    <label class="form-check-label" for="sc2">Ja</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div v-if="schoolcodeexists=='yes' || registration.input.schoolcode !=''" class="col-md-8 mb-1" v-bind:class="{ 'error': registration.errors.schoolcode }">
                                        <label>Dein Code:</label>
                                        <input :disabled="registered2ready"  type="text" v-model="registration.input.schoolcode" class="form-control form-control-lg form-control-tb mb-2">
                                    </div>


                                </div>



                                <div v-if="(questionnaire.registration_type=='post' && fieldActiveByVisitorType('email','post'))" class="row justify-content-center">
                                    <div class="col-md-8 mb-1" v-bind:class="{ 'error': registration.errors.email }">
                                        <label>{{ stringByVisitorType('label.email') }} <small style="font-weight: normal;">{{ stringByVisitorType('info.email') }}</small></label>
                                        <input :disabled="registered2ready" type="email" v-model="registration.input.email" class="form-control form-control-lg form-control-tb mb-2">
                                        <div v-if="questionnaire.optinmail_active==1" class="smallnote">Bitte durch Klick auf den Aktivierungslink in unserer Opt-In-E-Mail die E-Mail-Adresse bestätigen. Falls diese E-Mail nicht ankommt, bitte den Spam-Ordner checken.</div>
                                    </div>
                                </div>
                                <div v-if="(questionnaire.registration_type=='post' || questionnaire.registration_type=='prepost1' || questionnaire.registration_type=='prepost2') " class="row justify-content-center">
                                    <div v-if="fieldActiveByVisitorType('gender','post')" class="col-md-8 mt-2 mb-3" v-bind:class="{ 'error': registration.errors.gender }">
                                        <label>Geschlecht</label>
                                        <div class="row">
                                            <div class="col">
                                                <div class="custom-control custom-radio custom-control-inline">
                                                    <input :disabled="registered2ready" type="radio" id="genderb" name="gender" value="female" class="custom-control-input" v-model="registration.input.gender">
                                                    <label class="custom-control-label" for="genderb">Weiblich</label>
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="custom-control custom-radio custom-control-inline">
                                                    <input :disabled="registered2ready" type="radio" id="genderb2" name="gender" value="male" class="custom-control-input" v-model="registration.input.gender">
                                                    <label class="custom-control-label" for="genderb2">Männlich</label>
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="custom-control custom-radio custom-control-inline">
                                                    <input :disabled="registered2ready" type="radio" id="genderb3" name="gender" value="divers" class="custom-control-input" v-model="registration.input.gender">
                                                    <label class="custom-control-label" for="genderb3">Divers</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="fieldActiveByVisitorType('firstname','post')" class="col-md-8 mb-1" v-bind:class="{ 'error': registration.errors.firstname }">
                                        <label>{{ stringByVisitorType('label.firstname') }}<small style="font-weight: normal;">{{ stringByVisitorType('info.firstname') }}</small></label>
                                        <input :disabled="registered2ready"  type="text" v-model="registration.input.firstname" class="form-control form-control-lg form-control-tb mb-2">
                                    </div>
                                    <div v-if="fieldActiveByVisitorType('lastname','post')" class="col-md-8 mb-1" v-bind:class="{ 'error': registration.errors.lastname }">
                                        <label>Nachname</label>
                                        <input :disabled="registered2ready"  type="text" v-model="registration.input.lastname" class="form-control form-control-lg form-control-tb mb-2">
                                    </div>

                                    <div v-if="fieldActiveByVisitorType('birthday','post')" class="col-md-8 mb-1" v-bind:class="{ 'error': registration.errors.birthday }">
                                        <label>Geburtstag</label>
                                        <div class="">
                                            <input type="hidden" id="birthday_field" name="birthday_field" v_model="registration.input.birthday">
                                            <dropdown-datepicker :disabled="registered2ready" _v-model="registration.input.birthday" v-bind:on-change="onBirthdayChange" submit-id="birthday_field" ref="birthday"
                                                                 display-format="dmy" day-label="Tag" month-label="Monat" year-label="Jahr" min-date="1990-01-01" max-date="2006-12-31" v-bind:required="true" dropdownClass="form-control"
                                                                 wrapperClass="input-group mb-3" :day-suffix-values="['.', '.', '.', '.']" month-format="short"
                                                                 :monthLongValues="['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember']"
                                                                 :monthShortValues="['Jan.', 'Feb.', 'März', 'Apr.', 'Mai', 'Jun.', 'Jul.', 'Aug.', 'Sep.', 'Okt.', 'Nov.', 'Dez.']"
                                            ></dropdown-datepicker>
                                        </div>
                                    </div>
                                    <div v-if="fieldActiveByVisitorType('school_state','post')" class="col-md-8 mb-1" v-bind:class="{ 'error': registration.errors.school_state }">
                                        <label>Bundesland</label>
                                        <select :disabled="registered2ready" class="custom-select mb-3" v-model="registration.input.school_state">
                                            <option disabled value="">Bitte wählen</option>
                                            <option value="Baden-Württemberg">Baden-Württemberg</option>
                                            <option value="Bayern">Bayern</option>
                                            <option value="Berlin">Berlin</option>
                                            <option value="Brandenburg">Brandenburg</option>
                                            <option value="Bremen">Bremen</option>
                                            <option value="Hamburg">Hamburg</option>
                                            <option value="Hessen">Hessen</option>
                                            <option value="Mecklenburg-Vorpommern">Mecklenburg-Vorpommern</option>
                                            <option value="Niedersachsen">Niedersachsen</option>
                                            <option value="Nordrhein-Westfalen">Nordrhein-Westfalen</option>
                                            <option value="Rheinland-Pfalz">Rheinland-Pfalz</option>
                                            <option value="Saarland">Saarland</option>
                                            <option value="Sachsen">Sachsen</option>
                                            <option value="Sachsen-Anhalt">Sachsen-Anhalt</option>
                                            <option value="Schleswig-Holstein">Schleswig-Holstein</option>
                                            <option value="Thüringen">Thüringen</option>
                                        </select>
                                    </div>
                                    <div v-if="fieldActiveByVisitorType('school_type','post')" class="col-md-8 mt-2 mb-3" v-bind:class="{ 'error': registration.errors.school_type }">
                                        <label>Geht Ihr Kind auf eine Schule mit Möglichkeit auf Abitur?</label>
                                        <div class="row">
                                            <div class="col">
                                                <div class="custom-control custom-radio custom-control-inline">
                                                    <input :disabled="registered2ready" type="radio" id="school_type" name="school_type" value="SMA"  class="custom-control-input" v-model="registration.input.school_type">
                                                    <label class="custom-control-label" for="school_type">Ja</label>
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="custom-control custom-radio custom-control-inline">
                                                    <input :disabled="registered2ready" type="radio" id="school_type2" name="school_type" value="SOA" class="custom-control-input" v-model="registration.input.school_type">
                                                    <label class="custom-control-label" for="school_type2">Nein</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div v-if="(questionnaire.registration_type=='post') && fieldActiveByVisitorType('older13','post')" class="col-md-8 mb-2" v-bind:class="{ 'error': registration.errors.older13 }">
                                        <div class="form-check">
                                            <input :disabled="registered2ready" class="form-check-input" type="checkbox" value="" id="defaultCheck0" v-model="registration.input.older13">
                                            <label class="form-check-label" for="defaultCheck0">
                                                Hiermit bestätige ich, dass ich 14 Jahre oder älter bin.
                                            </label>
                                        </div>
                                    </div>

                                    <div v-if="(questionnaire.registration_type=='post') && fieldActiveByVisitorType('dsgvo','post')" class="col-md-8 mb-2" v-bind:class="{ 'error': registration.errors.dsgvo }">
                                        <div class="form-check">
                                            <input :disabled="registered2ready" class="form-check-input" type="checkbox" value="" id="defaultCheck1" v-model="registration.input.dsgvo">
                                            <label class="form-check-label" for="defaultCheck1">
                                                Ja, ich habe die Datenschutz&shy;bestimmungen gelesen, verstanden und akzeptiert (<a href="https://www.gubn.de/de/impressum_datenschutz.php" target="_blank" style="text-decoration:underline;">siehe hier</a>).
                                            </label>
                                        </div>
                                    </div>

                                    <div v-if="(questionnaire.registration_type=='post') && fieldActiveByVisitorType('hygiene','post')" class="col-md-8 mb-2" v-bind:class="{ 'error': registration.errors.hygiene }">
                                        <div class="form-check">
                                            <input :disabled="registered2ready" class="form-check-input" type="checkbox" value="" id="defaultCheckh" v-model="registration.input.hygiene">
                                            <label class="form-check-label" for="defaultCheckh">
                                                Ja, ich habe die <a href="https://admin.gubn.de/media/pdf/Schutz-_und_Hygienekonzept_GUBN_2021.pdf" target="_blank" style="text-decoration:underline;">Schutz- und Hygienehinweise</a> gelesen und werde mich vor Ort daran halten. (Pflichtangabe)
                                            </label>
                                        </div>
                                    </div>

                                    <div v-if="fieldActiveByVisitorType('marketing','post') && (questionnaire.registration_type=='post' || questionnaire.registration_type=='prepost2')" class="col-md-8 mb-2" v-bind:class="{ 'error': registration.errors.marketing }">
                                        <div class="form-check">
                                            <input :disabled="registered2ready" class="form-check-input" type="checkbox" value="" id="defaultCheck2" v-model="registration.input.marketing">
                                            <label class="form-check-label" for="defaultCheck2">
                                                <span v-if="registration.input.firstname!==''">{{ salutation_student }} {{ registration.input.firstname }},</span><span v-else>Bist du</span>
                                                einverstanden, dass ich dir über deine Teilnahme an der Chat Week/Traumberuf-Schülermesse hinaus Infos zu
                                                für dich passenden Ausbildungs-/Studiengängen per E-Mail schicke? Wenn das Thema irgendwann nicht mehr
                                                interessant für dich ist, kannst du jederzeit abbestellen.
                                            </label>
                                        </div>
                                    </div>

                                </div>



                                <transition name="bounce">
                                    <div v-if="registration.errors.email || registration.errors.gender || registration.errors.firstname || registration.errors.lastname || registration.errors.email || registration.errors.birthday || registration.errors.school_type || registration.errors.dsgvo" class="text-red text-center">Bitte die Eingaben prüfen.</div>
                                </transition>

                            </div>
                            <div v-if="!registered2ready" class="row justify-content-center">
                                <div class="col-md-8">
                                    <button type="button" class="btn btn-lg_ btn-block btn-pink zoomhover" v-text="stringByVisitorType('button.finish_questionnaire')" @click="register2();"></button>
                                </div>
                            </div>
                        </div>
                    </div>



                    <div v-if="readythanks===true" key='outro' id="outro" class="card shadow mt-3 speech-bubble-left">
                        <div class="card-body" v-html="questionnaire.outro_html"></div>
                    </div>
                </transition-group>


                <div style="height:80px">
                <transition name="appear">
                    <div class="typing-indicator mb-3" v-if="typing">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </transition>
                </div>
            </div>
        </div>
        <a id="end"></a>
    </div>
</template>

<script>
    import axios from 'axios';
    import _ from 'lodash';
    import DropdownDatepicker from 'vue-dropdown-datepicker';
    import {v4 as uuidv4} from 'uuid';

    export default {
        components: {
            _,axios,DropdownDatepicker
        },
        props : {
            questionnaire_uuid: {
                default: 0
            },
            mode: {
                default: ''
            },
            schoolcode: {
                default: ''
            }
        },
        mounted() {
            console.log('Q Component mounted.');
        },
        created() {
            this.getQuestions();
            console.log('Q Component created.');
            console.log('Q: Your QSID is: ' +this.qsid);
            if(this.schoolcode!=''){
                this.schoolcodeexists='yes';
            }
        },
        data: function(){
            return {
                sessionid: '',
                qsid: uuidv4(), // session identifier until reload
                dataloaded: false,
                usersaved:false,
                usersaved2:false,
                started:false,
                intro_skipped:false,
                loading:false,
                typing: false,
                error_message:'',
                schoolcodeexists:'yes',

                registration:{
                    errors: {
                        email:false,
                        gender:false,
                        schoolcode:false,
                        firstname:false,
                        lastname:false,
                        birthday:false,
                        school_state:false,
                        school_type:false,
                        dsgvo:false,
                        older13:false,
                        hygiene:false,
                        timeslot:false
                    },
                    input:{
                        visitor_type:'student',
                        email:'',
                        emailagain:'',
                        gender:'',
                        schoolcode:this.schoolcode,
                        firstname:'',
                        lastname:'',
                        birthday:'',
                        school_state:'',
                        school_type:'',
                        dsgvo:false,
                        id:null,
                        uuid:null,
                        older13:false,
                        hygiene:false,
                        timeslot:''
                    }
                },

                types: {
                    singlechoice:'Einzelauswahl',
                    multiplechoice:'Mehrfachauswahl',
                    multiplechoice_tags:'Mehrfachauswahl mit Tags',
                    yesno:'Ja/Nein',
                    input:'Freitext-Eingabe',
                    info:'Info'
                },

                questionnaire: {
                    registration_active:null,
                    registration_type:null,
                    visitor_type:null
                },
                bubbles: [],
                questions: [],
                clusters: {},
                questionsready: false,
                registered2ready:false,
                readythanks: false
            }
        },
        computed: {
            _questionQueue: function(){
                return this.questions
            },
            show_registration: function(){
                return (this.questionnaire.registration_active==1 && this.intro_skipped && this.questionnaire.registration_type!=='post');
            },
            show_registration2: function(){
                return (this.questionnaire.registration_active==1 && this.questionsready &&( this.questionnaire.registration_type=='post' || this.questionnaire.registration_type=='prepost1'  || this.questionnaire.registration_type=='prepost2'));
            },
            salutation_student: function(){
                if(this.registration.input.gender=='male'){ return 'Lieber '; }
                if(this.registration.input.gender=='female'){ return 'Liebe '; }
                if(this.registration.input.gender=='divers'){ return ''; }
                return '';
            }
        },

        watch: {
            schoolcodeexists: function (val) {
                if(val=='no'){
                    this.registration.input.schoolcode = '';
                }
            }
        },

        methods:{
            // all methods for backend communication:

            getQuestions() {
                var that = this
                let uri = '/questionnaire/'+this.questionnaire_uuid+'/questions'
                this.loading = true

                axios
                    .get(uri)
                    .then(response => {
                        console.log(response);
                        that.questions = that.questionAddProps(response.data.questions);
                        that.questionnaire = response.data.questionnaire;
                        that.clusters = {};
                        that.registration.input.visitor_type=that.questionnaire.visitor_type;
                        delete that.questionnaire.questions;
                        //that.addPropsToQuestions();

                        console.log('Fragen geladen.');
                        this.dataloaded=true;
                        this.sessionid = response.data.sessionid;
                        //this.next();
                    })
                    .catch(error => {
                        console.log(error)
                        that.error_message = 'Verbindungsfehler (Fragen)'
                    })
                    .finally(() => this.loading = false)
            },

            // Data manipulation:

            questionAddProps(questions){
                for (const [i, v] of questions.entries()) {
                    //console.log(i, v); // Prints "0 a", "1 b", "2 c"
                    if(v){
                        //v.order = i;
                        //v.status='pending';
                        //v.answers={};
                        //v.errors={};
                        //Vue.$set(array, index, newValue)
                        //this.$set(this.questions[i], i, 'strawberry');
                        questions[i]['order']=i;
                        questions[i]['status']='pending';
                        questions[i]['answers']={};
                        questions[i]['tags']=[];
                        questions[i]['errors']={};
                    }
                }
                return questions;
            },
            start(){
                var that = this;
                this.intro_skipped = true;
                if(this.questionnaire.registration_active!=1) {
                    this.next();
                } else if( this.questionnaire.registration_type==='post' ) {
                    this.getUID();
                } else {
                    setTimeout(function(){
                        that.$scrollTo('#registration' ,1500,{offset:-80});
                    },750);

                }
            },
            fieldActiveByVisitorType(fieldname,form){

                if(form !=='pre'){ form = 'post'; }

                let fieldsByType={
                    'pre': {
                        student: {
                            'schoolcode': false,
                            'school_name': false,
                            'timeslot': true,
                            'email': true,
                            'gender': true,
                            'firstname': true,
                            'lastname': true,
                            'birthday': false,
                            'school_state': false,
                            'school_type': false,
                            'dsgvo': true,
                            'marketing': true,
                            'older13': true,
                            'hygiene': false
                        },
                        booth_personal: {
                            'schoolcode': false,
                            'timeslot': false,
                            'school_name': false,
                            'email': true,
                            'gender': true,
                            'firstname': true,
                            'lastname': true,
                            'birthday': false,
                            'school_state': false,
                            'school_type': false,
                            'dsgvo': true,
                            'marketing': false,
                            'older13': false,
                            'hygiene': false
                        },
                        teacher: {
                            'schoolcode': false,
                            'timeslot': true,
                            'school_name': false,
                            'email': true,
                            'gender': true,
                            'firstname': true,
                            'lastname': true,
                            'birthday': false,
                            'school_state': false,
                            'school_type': false,
                            'dsgvo': true,
                            'marketing': false,
                            'older13': false,
                            'hygiene': false
                        },
                        parent: {
                            'schoolcode': false,
                            'timeslot': true,
                            'school_name': false,
                            'email': true,
                            'gender': true,
                            'firstname': true,
                            'lastname': true,
                            'birthday': false,
                            'school_state': true,
                            'school_type': true,
                            'dsgvo': true,
                            'marketing': false,
                            'older13': false,
                            'hygiene': false
                        },
                        default: {
                            'schoolcode': false,
                            'timeslot': true,
                            'school_name': false,
                            'email': true,
                            'gender': true,
                            'firstname': true,
                            'lastname': true,
                            'birthday': false,
                            'school_state': false,
                            'school_type': false,
                            'dsgvo': true,
                            'marketing': false,
                            'older13': false,
                            'hygiene': false
                        },
                    },
                    'post': {
                        student: {
                            'schoolcode': false,
                            'timeslot': true,
                            'school_name': false,
                            'email': true,
                            'gender': true,
                            'firstname': true,
                            'lastname': false,
                            'birthday': false,
                            'school_state': false,
                            'school_type': false,
                            'dsgvo': true,
                            'marketing': true,
                            'older13': true,
                            'hygiene': false
                        },
                        booth_personal: {
                            'schoolcode': false,
                            'timeslot': false,
                            'school_name': false,
                            'email': true,
                            'gender': true,
                            'firstname': true,
                            'lastname': true,
                            'birthday': false,
                            'school_state': false,
                            'school_type': false,
                            'dsgvo': true,
                            'marketing': false,
                            'older13': false,
                            'hygiene': false
                        },
                        teacher: {
                            'schoolcode': false,
                            'timeslot': true,
                            'school_name': false,
                            'email': true,
                            'gender': true,
                            'firstname': true,
                            'lastname': true,
                            'birthday': false,
                            'school_state': false,
                            'school_type': false,
                            'dsgvo': true,
                            'marketing': false,
                            'older13': false,
                            'hygiene': false
                        },
                        parent: {
                            'schoolcode': false,
                            'timeslot': true,
                            'school_name': false,
                            'email': true,
                            'gender': true,
                            'firstname': true,
                            'lastname': true,
                            'birthday': false,
                            'school_state': true,
                            'school_type': true,
                            'dsgvo': true,
                            'marketing': false,
                            'older13': false,
                            'hygiene': false
                        },
                        default: {
                            'schoolcode': false,
                            'timeslot': true,
                            'school_name': false,
                            'email': true,
                            'gender': true,
                            'firstname': true,
                            'lastname': true,
                            'birthday': false,
                            'school_state': false,
                            'school_type': false,
                            'dsgvo': true,
                            'marketing': false,
                            'older13': false,
                            'hygiene': false
                        },
                    }
                }
                console.log('fieldcheck: ',fieldname,this.questionnaire.visitor_type,fieldsByType[form]['default'][fieldname]);
                if(this.questionnaire.visitor_type!='student' && this.questionnaire.visitor_type!='booth_personal' && this.questionnaire.visitor_type!='teacher' && this.questionnaire.visitor_type!='parent'){
                    return fieldsByType[form]['default'][fieldname];
                }
                return fieldsByType[form][this.questionnaire.visitor_type][fieldname];
            },

            stringByVisitorType(stringname){
                let stringsByType={
                    student:{
                        'label.email': 'Deine E-Mail',
                        'info.email': '',
                        'label.firstname': 'Dein Vorname',
                        'info.firstname': ', hier kannst du auch deinen Spitznamen angeben.',
                        'button.finish_questionnaire': 'Jetzt Vorschläge für passende Hochschulen, Unternehmen und Behörden bekommen!',
                    },
                    default:{
                        'label.email': 'E-Mail',
                        'info.email':'',
                        'label.firstname': 'Vorname',
                        'info.firstname': ', hier kannst du auch deinen Spitznamen angeben.',
                        'button.finish_questionnaire': 'Umfrage abschließen',
                    },
                }
                console.log('stringcheck: ',stringname,this.questionnaire.visitor_type,stringsByType['default'][stringname]);
                if(this.questionnaire.visitor_type!='student'){
                    return stringsByType['default'][stringname];
                }
                return stringsByType[this.questionnaire.visitor_type][stringname];
            },

            register(){
                // validate & save the register form input
                var errorcount = 0;
                this.registration.errors.email=false;
                this.registration.errors.gender=false;
                this.registration.errors.schoolcode=false;
                this.registration.errors.firstname=false;
                this.registration.errors.lastname=false;
                this.registration.errors.birthday=false;
                this.registration.errors.school_state=false;
                this.registration.errors.school_type=false;
                this.registration.errors.dsgvo=false;
                this.registration.errors.older13=false;
                this.registration.errors.hygiene=false;
                this.registration.errors.timeslot=false;

                if(this.registration.input.email=='' || !this.validateEmail(this.registration.input.email) || this.registration.input.email!==this.registration.input.emailagain ){
                    this.registration.errors.email=true;
                    errorcount++;
                }
                if(this.questionnaire.registration_type=='prepost2') {
                    if (this.registration.input.firstname == '' && this.fieldActiveByVisitorType('firstname','post')) {
                        this.registration.errors.firstname = true;
                        errorcount++;
                    }
                }
                if(this.questionnaire.registration_type=='pre' || this.questionnaire.registration_type=='none') {
                    if (this.registration.input.gender == '' && this.fieldActiveByVisitorType('gender','pre')) {
                        this.registration.errors.gender = true;
                        errorcount++;
                    }
                    if (this.registration.input.firstname == '' && this.fieldActiveByVisitorType('firstname','pre')) {
                        this.registration.errors.firstname = true;
                        errorcount++;
                    }
                    if (this.registration.input.lastname == '' && this.fieldActiveByVisitorType('lastname','pre')) {
                        this.registration.errors.lastname = true;
                        errorcount++;
                    }
                    if (this.registration.input.birthday == '' && this.fieldActiveByVisitorType('birthday','pre')) {
                        this.registration.errors.birthday = true;
                        errorcount++;
                    }
                    if (this.registration.input.school_state == '' && this.fieldActiveByVisitorType('school_state','pre')) {
                        this.registration.errors.school_state = true;
                        errorcount++;
                    }
                    if (this.registration.input.school_type == '' && this.fieldActiveByVisitorType('school_type','pre')) {
                        this.registration.errors.school_type = true;
                        errorcount++;
                    }
                    if (this.questionnaire.tasks==='visitor_ticket' && this.registration.input.timeslot === '' && this.fieldActiveByVisitorType('timeslot','pre')) {
                        this.registration.errors.timeslot = true;
                        errorcount++;
                    }
                }
                if(!this.registration.input.dsgvo && this.fieldActiveByVisitorType('dsgvo',this.questionnaire.registration_type)){
                    this.registration.errors.dsgvo=true;
                    errorcount++;
                }
                if(!this.registration.input.older13 && this.fieldActiveByVisitorType('older13',this.questionnaire.registration_type)){
                    this.registration.errors.older13=true;
                    errorcount++;
                }
                if(!this.registration.input.hygiene && this.fieldActiveByVisitorType('hygiene',this.questionnaire.registration_type)){
                    this.registration.errors.hygiene=true;
                    errorcount++;
                }
                console.log(' validate & save the register form input. errorcount:'+errorcount);
                if(errorcount==0){
                    console.log('next');

                    // Save data to server

                    this.saveUser(1);
                    //this.next();

                } else {
                    this.$forceUpdate();
                }
            },

            register2(){
                // validate & save the register form input
                var errorcount = 0;
                this.registration.errors.email=false;
                this.registration.errors.gender=false;
                this.registration.errors.schoolcode=false;
                this.registration.errors.firstname=false;
                this.registration.errors.lastname=false;
                this.registration.errors.birthday=false;
                this.registration.errors.school_state=false;
                this.registration.errors.school_type=false;
                this.registration.errors.dsgvo=false;
                this.registration.errors.older13=false;
                this.registration.errors.hygiene=false;

                if(this.questionnaire.registration_type==='post') {
                    if(this.registration.input.email==='' || !this.validateEmail(this.registration.input.email)){
                        this.registration.errors.email=true;
                        errorcount++;
                    }
                }
                if(this.questionnaire.registration_type==='post' || this.questionnaire.registration_type==='prepost1'  || this.questionnaire.registration_type==='prepost2') {
                    if (this.registration.input.gender == '' && this.fieldActiveByVisitorType('gender','post') ) {
                        this.registration.errors.gender = true;
                        errorcount++;
                    }
                    if (this.registration.input.firstname === '' && this.fieldActiveByVisitorType('firstname','post')) {
                        this.registration.errors.firstname = true;
                        errorcount++;
                    }
                    if (this.registration.input.lastname === '' && this.fieldActiveByVisitorType('lastname','post')) {
                        this.registration.errors.lastname = true;
                        errorcount++;
                    }
                    if (this.registration.input.birthday === '' && this.fieldActiveByVisitorType('birthday','post')) {
                        this.registration.errors.birthday = true;
                        errorcount++;
                    }
                    if (this.registration.input.school_state == '' && this.fieldActiveByVisitorType('school_state','post')) {
                        this.registration.errors.school_state = true;
                        errorcount++;
                    }
                    if (this.registration.input.school_type == '' && this.fieldActiveByVisitorType('school_type','post')) {
                        this.registration.errors.school_type = true;
                        errorcount++;
                    }
                }
                if(this.questionnaire.registration_type==='post') {
                    if(!this.registration.input.dsgvo && this.fieldActiveByVisitorType('dsgvo','post')){
                        this.registration.errors.dsgvo=true;
                        errorcount++;
                    }
                }
                if(this.questionnaire.registration_type==='post') {
                    if(!this.registration.input.older13 && this.fieldActiveByVisitorType('older13','post')){
                        this.registration.errors.older13=true;
                        errorcount++;
                    }
                }
                if(this.questionnaire.registration_type==='post') {
                    if(!this.registration.input.hygiene && this.fieldActiveByVisitorType('hygiene','post')){
                        this.registration.errors.hygiene=true;
                        errorcount++;
                    }
                }
                console.log(' validate & save the register2 form input. errorcount:'+errorcount);
                if(errorcount===0){
                    console.log('reg2 no errors - next');

                    // Save data to server

                    this.saveUser(2);
                    //this.next();

                } else {
                    this.$forceUpdate();
                }
            },

            onBirthdayChange(day, month, year){
                if(day != '' && month != '' && year != '' && day != null && month != null && year != null){
                    this.registration.input.birthday = year+'-'+month+'-'+day;
                } else {
                    this.registration.input.birthday='';
                }
            },

            getUID(){
                this.saveUser(0);
            },
            saveUser(regnr){

                if(this.mode==='test'){
                    console.log('Testmode. User nicht gesichert.');
                    if(regnr==0){
                        this.usersaved=true;
                        this.next();
                    }
                    else if(regnr==1){
                        this.usersaved=true;
                        this.next();
                    }
                    else if(regnr==2){
                        this.usersaved2=true;
                        this.registered2ready = true;
                        this.next();
                    } else {
                        this.next();
                    }
                } else {

                    var that = this;
                    let uri = '/questionnaire/'+this.questionnaire_uuid+'/participant';
                    this.loading = true;

                    var data = this.registration.input;

                    axios
                        .post(uri,data)
                        .then(response => {
                            console.log(response)

                            console.log('User gesichert.');

                            //this.visitor_uuid = response.data.visitor_uuid;
                            //this.visitor_id = response.data.visitor_id;
                            this.registration.input.id=response.data.visitor_id;
                            this.registration.input.uuid=response.data.visitor_uuid;
                            if(regnr==0){
                                this.usersaved=true;
                                this.next();
                            }
                            if(regnr==1){
                                this.usersaved=true;
                                this.next();
                            }
                            if(regnr==2){
                                this.usersaved2=true;
                                this.registered2ready = true;
                                this.next();
                            }
                        })
                        .catch(error => {
                            console.log(error)
                            that.error_message = 'Verbindungsfehler (Register)'
                        })
                        .finally(() => this.loading = false)
                }
            },

            validateEmail(inputText){
                var mailformat = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;
                if(inputText!='' && inputText.match(mailformat)){
                    console.log("Valid email address!");
                    return true;
                } else {
                    console.log("You have entered an invalid email address!");
                    return false;
                }
            },
            validate(rule,prop,i,question){
                if($rule=='notempty'){

                }
            },
            removeErrorMessages(index){
                this.bubbles[index]['errors']={};
            },


            toggleTag(question,index,tag_id){

                console.log('toggle:',question);
                if(question.status!=='answered'){

                    var max = this.asInt(this.bubbles[index]['properties']['inputcountmax']);
                    var ac =  this.asInt(this.bubbles[index]['tags'].length);

                    if(question.type=='singlechoice'){
                        this.bubbles[index]['tags'] = [tag_id]
                    } else if(this.bubbles[index]['status']=='active'){

                        if( _.includes(this.bubbles[index]['tags'], tag_id) ){
                            console.log('it‘s included. Remove it:');
                            _.pull(this.bubbles[index]['tags'],tag_id)
                        } else {
                            if(ac>0 && max<=ac){
                                console.log('max erreicht.');
                            }else {
                                console.log(ac,max);
                                console.log('it‘s NOT included. Add it:');
                                this.bubbles[index]['tags'].push(tag_id);
                            }
                        }
                        this.$forceUpdate();

                    }
                } else {
                    console.log('off');
                }
            },

            isTagActive(question,tag_id){
                return _.includes(question.tags, tag_id);
            },
            hasTags(question){
                return _.uniq(question.tags).length>0 ? true:false;
            },
            hasAllTags(question,index){
                return _.uniq(question.tags).length>0 ? true:false;
            },
            noTags(index){
                if(this.bubbles[index]['status']=='active'){
                    this.bubbles[index]['tags']=[];
                    this.$forceUpdate();
                }
            },
            allTags(question,index){
                if(this.bubbles[index]['status']=='active'){
                    this.bubbles[index]['tags']=[];
                    this.$forceUpdate();
                }
            },

            submitQuestion(index,buttontype,question,e){
                // Validate:
                let that = this;
                let errorcount = 0;

                console.log('input type:',that.bubbles[index]['type']);
                console.log('input count:',that.bubbles[index]['properties']['inputcount']);
                console.log('input countmin:',that.bubbles[index]['properties']['inputcountmin']);

                var min = this.asInt(that.bubbles[index]['properties']['inputcountmin']);
                var max = this.asInt(that.bubbles[index]['properties']['inputcountmax']);
                var ac =  this.asInt(that.bubbles[index]['tags'].length);

                var cluster = that.bubbles[index]['properties']['cluster'];


                switch (that.bubbles[index]['type']) {

                    case 'yesno':
                        that.clusters[cluster]=[buttontype];
                        break;

                    case 'singlechoice':

                        console.log('tag count:',that.bubbles[index]['tags'].length);

                        if(this.asInt(that.bubbles[index]['tags'].length)==0 && min>0){
                            console.log('error');
                            that.bubbles[index]['errors']['general'] = 'Bitte wähle eine Option aus.';
                            errorcount++;
                        } else {
                            that.bubbles[index]['errors']['general'] ='';
                            that.clusters[cluster]=that.bubbles[index]['tags'];
                        }
                        this.$forceUpdate();
                        break;
                    case 'multiplechoice_tags':

                        if(this.asInt(that.bubbles[index]['tags'].length)==0 && min>0 && !that.bubbles[index]['properties']['notaglabel'] ){
                            console.log('error');
                            that.bubbles[index]['errors']['general'] = 'Bitte wähle mindestens eine Option aus.';
                            errorcount++;
                        } else {
                            that.bubbles[index]['errors']['general'] ='';
                            that.clusters[cluster]=that.bubbles[index]['tags'];
                        }

                        this.$forceUpdate();
                        break;

                    case 'multiplechoice':


                        console.log('tag count:',ac,'min',min);

                        if(min>0 && ac < min){
                            console.log('error');
                            that.bubbles[index]['errors']['general'] = 'Bitte wähle '+ min +' Option(en) aus.';
                            errorcount++;
                        } else {
                            that.bubbles[index]['errors']['general'] ='';
                            that.clusters[cluster]=that.bubbles[index]['tags'];
                        }
                        this.$forceUpdate();
                        break;

                    case 'input':

                        that.clusters[cluster]={};

                        if(min){
                                that.bubbles[index]['errors']={};
                                if(!that.bubbles[index]['answers']['input1'] || that.bubbles[index]['answers']['input1']==''){
                                    // first input should not be empty!
                                    that.bubbles[index]['errors']['input1'] = true;
                                    errorcount++;
                                }
                        }
                        if(this.asInt(that.bubbles[index]['properties']['inputcountmin'])>1){
                            if( that.bubbles[index]['properties']['inputcount']>=2 && (!that.bubbles[index]['answers']['input2']  || that.bubbles[index]['answers']['input2']=='')){
                                that.bubbles[index]['errors']['input2'] = true;
                                errorcount++;
                            }
                        }
                        if(this.asInt(that.bubbles[index]['properties']['inputcountmin'])>2){
                            if(that.bubbles[index]['properties']['inputcount'] >=3 && (!that.bubbles[index]['answers']['input3'] || that.bubbles[index]['answers']['input3']=='')){
                                that.bubbles[index]['errors']['input3'] = true;
                                errorcount++;
                            }
                        }
                        if(errorcount==0){
                            if(that.bubbles[index]['answers']['input1'] && that.bubbles[index]['answers']['input1']!=''){
                                that.clusters[cluster]['input1']=that.bubbles[index]['answers']['input1'];
                            }
                            if(that.bubbles[index]['answers']['input2'] && that.bubbles[index]['answers']['input2']!=''){
                                that.clusters[cluster]['input2']=that.bubbles[index]['answers']['input2'];
                            }
                            if(that.bubbles[index]['answers']['input3'] && that.bubbles[index]['answers']['input3']!=''){
                                that.clusters[cluster]['input3']=that.bubbles[index]['answers']['input3'];
                            }
                        }

                        this.$forceUpdate();
                        break;

                    default:
                        break;
                }


                // Show next:
                console.log(errorcount,index,buttontype,question,e);
                if(errorcount==0){

                    // Save answers to this question:

                    this.saveAnswer(question.id, cluster,that.clusters[cluster]);

                    //this.next();
                }

            },

            saveAnswer(question_id,cluster,answers){

                if(this.mode==='test'){
                    console.log('Testmode. Antwort nicht gesichert.');
                    this.next();
                } else {

                    var that = this;
                    let uri = '/questionnaire/'+this.questionnaire_uuid+'/answer';
                    this.loading = true;

                    var data = {
                        question_id:question_id,
                        cluster:cluster,
                        answers:answers,
                        visitor_uuid: this.registration.input.uuid,
                        visitor_id: this.registration.input.id,
                        sessionid: this.sessionid,
                        qsid: this.qsid
                    };

                    axios
                        .post(uri,data)
                        .then(response => {
                            console.log(response)

                            console.log('Antwort gesichert.');
                            //this.usersaved=true;
                            this.next();
                        })
                        .catch(error => {
                            console.log(error)
                            that.error_message = 'Verbindungsfehler (Register)'
                        })
                        .finally(() => this.loading = false)
                }
            },

            next(){

                this.started=true;

                var that = this;
                this.typing = true;
                setTimeout(function(){

                    if(_.last(that.bubbles)){
                        _.last(that.bubbles).status='answered';
                    }

                    // is there a dependency in the next question?
                    var dependency_passed = false;

                    while(!dependency_passed && that.questions.length>0){
                        console.log('that questions 0:',that.questions);
                        var question = that.questions[0];
                        console.log('new actual question:',question);
                        question.status='active';
                        that.questions.shift();

                        if(typeof question.properties.dependency  !== 'undefined' && question.properties.dependency.mode && question.properties.dependency.mode!='--'){
                            console.log('check dependency',question.properties.dependency );
                            console.log('this ', that.clusters[question.properties.dependency.cluster], 'must '+question.properties.dependency.mode, question.properties.dependency.value )
                            if(question.properties.dependency.mode=='contains' && that.clusters[question.properties.dependency.cluster] && that.clusters[question.properties.dependency.cluster].includes(question.properties.dependency.value)){
                                dependency_passed = true;
                                console.log('check dependency contains passed.');
                            }
                            if(question.properties.dependency.mode=='contains-not' && that.clusters[question.properties.dependency.cluster] && !that.clusters[question.properties.dependency.cluster].includes(question.properties.dependency.value)){
                                dependency_passed = true;
                                console.log('check dependency contains-not passed.');
                            }
                            if(question.properties.dependency.mode=='isset' && that.clusters[question.properties.dependency.cluster] && _.size(that.clusters[question.properties.dependency.cluster])>0 ){
                                dependency_passed = true;
                                console.log('check dependency isset passed. ', _.size(that.clusters[question.properties.dependency.cluster]) );
                            } else {
                                console.log('check dependency isset NOT passed. ', _.size(that.clusters[question.properties.dependency.cluster]) );
                            }

                       } else {
                            dependency_passed = true;
                       }
                    }
                    // / dependencies checked. Skipped unallowed if necessary.

                    console.log(that.questions.length, ' questions left.');
                    if(question){
                        that.bubbles.push(question);
                    }

                    that.typing = false;

                    console.log('typeof question',typeof question);
                    //that.typing = false;
                    setTimeout(function(){
                        if (typeof question == 'object'){
                            //var cancelScroll =
                            that.$scrollTo('#bubble'+question.id ,1500,{offset:-80});
                            //that.$scrollTo('#end' ,1500,{offset:-80});
                        } else {
                            console.log('Ready. Next?');
                            that.questionsready=true;

                            if(that.show_registration2 && !that.usersaved2){
                                console.log('scroll to reg2!');
                                setTimeout(function(){
                                    that.$scrollTo('#registration2' ,1500,{offset:-80});
                                },500);

                            }
                            if(that.questionnaire.finished_redirect_active===1 && that.questionnaire.finished_redirect_url!=='' && that.usersaved2){
                                console.log('Ready. Now redirect to'+that.questionnaire.finished_redirect_url)
                                window.location.href = that.questionnaire.finished_redirect_url;
                            }
                            if(that.outro_html!='' && that.usersaved2){
                                that.readythanks=true;
                                console.log('Ready. Say thanks');
                                setTimeout(function(){
                                    that.$scrollTo('#outro' ,1500,{offset:-80});
                                },250);
                            }
                        }
                    },750);

                }, 750);
            },

            asInt(x){
                const parsed = parseInt(x);
                if (isNaN(parsed)) { return 0; }
                return parsed;
            },
            placeholders(str){
                if(this.registration.input.firstname) {
                    str = str.replace('[firstname]',this.registration.input.firstname);
                    str = str.replace('[Vorname]',this.registration.input.firstname);
                    str = str.replace('[vorname]',this.registration.input.firstname);
                }
                if(this.registration.input.lastname) {
                    str = str.replace('[lastname]',this.registration.input.lastname);
                    str = str.replace('[Nachname]',this.registration.input.lastname);
                    str = str.replace('[nachname]',this.registration.input.lastname);
                }
                if(this.registration.input.email) {
                    str = str.replace('[email]',this.registration.input.email);
                    str = str.replace('[Email]',this.registration.input.email);
                }
                return str;
            }

        }
    }
</script>



<style lang="scss" scoped>

h3, .h3, h3.section {
    font-size: 26px!important;
}

h4, .h4 {
    font-size: 22px;
}
p {
    font-size: 20px;
}
label {
    font-size: 14px;
    font-weight: bold;
}
small {
    font-size: 80%;
}
input, button {
    font-size: 17px;
}
h4.questiontext {
    font-size: 22px;
}
.h4.answertext {
    font-size: 16px;
    background: transparent;
    color: black;
    -webkit-text-fill-color: black;
    font-weight: 300;
    -webkit-background-clip: text;
    -webkit-text-fill-color: black;
    -webkit-background-clip: initial;
}
p.subline {
    font-size: 17px;
}
p.subline h4{
    font-size: 16px;
    background: transparent;
    color: black;
    -webkit-text-fill-color: black;
    font-weight: bold;
    -webkit-background-clip: text;
    -webkit-text-fill-color: black;
    -webkit-background-clip: initial;
}
.btn.btn-lg {
    font-size: 1.2rem !important;
}
.badge {
    border-radius: 4px;
    font-weight: bold;
    text-transform: none;
    padding: 0.4rem;
    hyphens: auto;
    word-wrap: normal;
    white-space: break-spaces;
}


.badge-tag {
    font-size: 100%;
    padding: 0.7em 0.5em;
    border-radius: 1.2em;
    cursor: pointer;
    transition: all .2s ease-in-out;
}
.badge-tag-gray {
    color:black;
    background: rgb(178, 177, 177);
    animation: fade_in_show .5s
}

.answered .badge-tag-gray:not(.active) {
    display: none;
    //opacity: 0;
    //transform: scale(0);
    //animation: fade_in_show 1.5s;
}


.badge-tag:hover {
    color:white;
    background: rgb(115, 115, 115);
    transform: scale(1.025);
}
.badge-tag-gray:active , .badge-tag-gray.active {
    background-color: black;
    color:white;
}
.badge-tag-danger {
    background-color: white;
    border: solid 2px red;
    color: red;
    animation: fade_in_show 1s
}
.badge-tag-danger:active , .badge-tag-danger.active {
    background-color: red;
    color:white;
}
.answered .badge-tag-danger:not(.active) {
    display: none;
}


 @media screen and (max-width: 400px) {

    input, button {
        font-size: 16px;
    }
    .btn { padding: 10px 10px 10px 10px; }

}




input.form-control-tb{
    border:solid 1px gray;
}


.list-item {
  display: inline-block;
  margin-right: 10px;
}
.list-enter-active,
.list-leave-active {
  transition: all 1s ease;
}
.list-enter-from,
.list-leave-to {
  opacity: 0;
  transform: translateY(30px);
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
transition: all .1s ease;
}
.slide-fade-leave-active {
transition: all .1s ease;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
transform: scaleY(0);
opacity: 0;
}


.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}


.scale-enter-active {
  animation: scale-in .5s;
}
.scale-leave-active {
  animation: scale-in .5s reverse;
}
@keyframes scale-in {
  0% {
    transform: scaleY(0);
    transform: scaleX(1);
  }
  50% {
    transform: scaleY(.3);
    transform: scaleX(1);
  }
  100% {
    transform: scaleY(1);
    transform: scaleX(1);
  }
}




.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.move {
  cursor: move;
}

.pointer {
  cursor: pointer;
}


div.bubbles-bg {background-color: silver;}

div.questionnaire {
    min-height: 100px;
}
.speech-bubble-left .card-header, .speech-bubble-right .card-header, .speech-bubble-answered.card-header {
	border-radius: .9em .9em 0 0;
    padding: 0.3rem 1.25rem;
}
.speech-bubble-left .card-footer, .speech-bubble-right .card-footer, .speech-bubble-answered.card-footer {
	border-radius: 0 0 .9em .9em;
    padding: 0.3rem 1.25rem;
}

.speech-bubble-left, .speech-bubble-right, .speech-bubble-answered  {
	position: relative;
	background: #ffffff;
	border-radius: .9em;
}

.speech-bubble-left:after {
	content: '';
	position: absolute;
	left: 0;
	top: 50%;
	width: 0;
	height: 0;
	border: 15px solid transparent;
	border-right-color: #ffffff;
	border-left: 0;
	margin-top: -15px;
	margin-left: -15px;
}
.speech-bubble-right:after, .speech-bubble-answered:after {
	content: '';
	position: absolute;
	right: 0;
	top: 50%;
	width: 0;
	height: 0;
	border: 15px solid transparent;
	border-left-color: #ffffff;
	border-right: 0;
	margin-top: -15px;
	margin-right: -15px;
}





.animated {
    display: block;
}

.animated.v-enter {
    animation: fadein .5s;
}

.animated.v-leave {
    animation: fadeout .5s;
}

@keyframes fadein {
    0% {
        transform: scale(0);
    }
    50% {
        transform: scale(1.5);
    }
    100% {
        transform: scale(1);
    }
}

@keyframes fadeout {
    0% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.5);
    }
    100% {
        transform: scale(0);
    }
}

.lightborder {
    border: solid 1px #E5E3E6;
}

.uppercase{
    text-transform: uppercase;
}

.custom-pic-input {
  visibility: hidden;
  width:0; height:0;float:left;
}

.custom-pic-input::-webkit-file-upload-button {
  visibility: hidden;
}
._custom-pic-input::before {
  content: 'Select some files';
  display: inline-block;
  background: white;
  border: 1px solid #999;
  border-radius: 3px;
  padding: 5px 8px;
  outline: none;
  white-space: nowrap;
  -webkit-user-select: none;
  cursor: pointer;
  text-shadow: 1px 1px #fff;
  font-weight: 700;
  font-size: 10pt;
}
.custom-pic-input:hover::before {
  border-color: black;
}
.custom-pic-input:active::before {
  background:white;
}



::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  font-style: italic;
  opacity: 0.8; /* Firefox */
}

:-ms-input-placeholder { /* Internet Explorer 10-11 */
  font-style: italic;
}

::-ms-input-placeholder { /* Microsoft Edge */
  font-style: italic;
}




@keyframes fade_in_show {
     0% {
          opacity: 0;
          transform: scale(0)
     }

     100% {
          opacity: 1;
          transform: scale(1)
     }
}

.zoomhover { transition: all .2s ease-in-out; }
.zoomhover:hover { transform: scale(1.025); }



.answered .notselected{
    display:none;
}




img.rounded-left-lg {
    border-radius: 0.3rem 0 0 0.3rem !important;
}



.typing-indicator {
	$ti-color-bg: #ffffff;
	background-color: rgba($ti-color-bg, 1);
	will-change: transform;
	width: auto;
	border-radius: 25px;
	padding: 15px;
	display: table;
	margin: 0 auto;
	margin-top:10px;
	position: relative;
	animation: 1.5s bulge infinite ease-out;
	&::before,
	&::after {
	  content: '';
	  position: absolute;
	  bottom: -2px;
	  left: -2px;
	  height: 20px;
	  width: 20px;
	  border-radius: 50%;
	  background-color:  rgba($ti-color-bg, 1);
	}
	&::after {
	  height: 10px;
	  width: 10px;
	  left: -10px;
	  bottom: -5px;
	}
	span {
	  height: 15px;
	  width: 15px;
	  float: left;
	  margin: 0 1px;
	  background-color: #9E9EA1;
	  display: block;
	  border-radius: 50%;
	  opacity: 0.4;
	  @for $i from 1 through 3 {
		&:nth-of-type(#{$i}) {
		  animation: 1s blink infinite ($i * .3333s);
		}
	  }
	}
  }

  @keyframes blink {
	50% {
	  opacity: 1;
	}
  }

  @keyframes bulge {
	50% {
	  transform: scale(.8);
	}
  }




.error, .error label, .text-red {
    color:red;
}
.errortext {
    display: none;
}
.error .errortext {
    display: block;
}
.error input, .error select {
    color:red;border-color: red;
}

.date-dropdowns select {
    padding: 8px 5px;
}
.smallnote {font-size: 12px; line-height: 14px; }


/*
[type="checkbox"] {
    position: relative;
    left: 15px;
    top: -4px;
    z-index: 0;
    -webkit-appearance: none;
}
[type="checkbox"] + label {
    position: absolute;
}
[type="checkbox"] + label::before {
    width: 15px;
    height: 15px;
    border-radius: 5px;
    border: 2px solid #8cad2d;
    background-color: #fff;
    display: block;
    content: "";
    float: left;
    margin-right: 5px;
    z-index: 5;
    position: relative;
}
[type="checkbox"]:checked+label::before {
    box-shadow: inset 0px 0px 0px 3px #fff;
    background-color: #8cad2d;
}
 */

.form-check-label {
    margin-left: 10px;
}
checkbox {
    font-size: 25px;
    margin: 5px 10px 0 -20px;
}
</style>

